module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = ./node_modules/lodash/first.js
// module chunks = 54